import LxcError from "~/core/models/LxcError.class";
import type { Pki } from "~/modules/pki/models/Pki.interface";
import pkiService from "~/modules/pki/services/pki.service";

export function useCreatePki() {
  const service = pkiService.createPki.bind(pkiService);

  const isLoading = ref(false);
  const error: Ref<LxcError | null> = ref(null);

  async function createPki(pki: Pki) {
    isLoading.value = true;
    error.value = null;

    const response = await service(pki);

    if (LxcError.check(response)) {
      error.value = response;
    }

    isLoading.value = false;
  }

  return {
    createPki,
    isLoading,
    error,
  };
}
